<section class="legal-shell">
  <div class="legal-card">
    <p class="eyebrow">Page publique</p>
    <h1>Politique de confidentialité</h1>
    <p class="lead">
      AfriFood collecte et traite un volume limité de données personnelles pour fournir l’accès au
      compte, les fonctionnalités recettes, communautaires et support dans l’application et
      l’interface web.
    </p>

    <div class="section">
      <h2>Données susceptibles d’être collectées</h2>
      <ul>
        <li>Données de compte comme l’adresse email, le nom affiché et le mot de passe chiffré.</li>
        <li>Données de profil que vous choisissez de fournir dans l’application ou au support.</li>
        <li>Données techniques et d’usage nécessaires à la sécurité et à l’amélioration du service.</li>
        <li>Contenus publiés, notamment recettes, commentaires, avis, signalements et médias.</li>
      </ul>
    </div>

    <div class="section">
      <h2>Pourquoi nous utilisons ces données</h2>
      <ul>
        <li>Authentifier votre compte et sécuriser le service.</li>
        <li>Afficher votre profil, vos recettes et vos interactions communautaires.</li>
        <li>Traiter la modération, la prévention des abus, le support et les obligations légales.</li>
        <li>Faire fonctionner les notifications, les diagnostics et les améliorations du service.</li>
      </ul>
    </div>

    <div class="section">
      <h2>Demande de suppression des données</h2>
      <p>
        Si vous souhaitez supprimer votre compte et les données personnelles associées, envoyez un
        email à
        <a href="mailto:support.afrifood@afrimoov.com">support.afrifood@afrimoov.com</a>.
      </p>
      <p>Pour accélérer le traitement, merci d’indiquer :</p>
      <ul>
        <li>l’adresse email utilisée pour le compte,</li>
        <li>votre nom complet ou nom affiché,</li>
        <li>tout identifiant utile lié au compte,</li>
        <li>une demande explicite de suppression de vos données.</li>
      </ul>
      <p>
        Une vérification complémentaire peut être demandée avant suppression. Certaines données
        peuvent être conservées lorsque cela est nécessaire pour la sécurité, la prévention de la
        fraude ou le respect d’obligations légales.
      </p>
    </div>

    <div class="section">
      <h2>Contact</h2>
      <p>
        Pour toute question sur la confidentialité ou le support, contactez
        <a href="mailto:support.afrifood@afrimoov.com">support.afrifood@afrimoov.com</a>.
      </p>
    </div>

    <div class="actions">
      <a routerLink="/data-deletion-request">Voir la procédure de suppression</a>
      <a routerLink="/">Retour à l’accueil</a>
    </div>
  </div>
</section>
